import styles from './BackButton.module.scss';
import ArrowLeft from '@src/assets/arrowLeft.png';

export default function BackButton({onClick}: {onClick: () => void}) {
    return (
        <div className={styles.backButton} onClick={onClick}>
            <img src={ArrowLeft} alt="ArrowLeft" width="12" height="9" style={{ margin: '0 auto' }}/>
            <p className={styles.backButtonLabel}>Revenir</p>
        </div>
    );
}
